import React from 'react';
import logo from '../logo.jpg';

function Home() {


    return ( <div className = "App" >
        <header className = "App-header" >
        <img src = { logo }
        className = "App-logo"
        alt = "logo" / >

        <a className = "App-link"
        href = "https://www.facebook.com/techlearnland"
        target = "_blank"
        rel = "noopener noreferrer" >
        Tech Learn Land </a> </header> <p className = "alert alert-success" >
        สอนเขียนโปรแกรม สอนออนไลน์ สอนสด ตั วต่ อตั ว ผ่ านการรีโมทหน้ าจอ สอนตั้ งแต่ ประถม ถึงวั ยทำงาน </p>

        <a className = "App-link"
        href = "https://www.facebook.com/techlearnland"
        target = "_blank"
        rel = "noopener noreferrer" >
        facebook </a> </div >
    );
}

export default Home;